import { Layers, X } from "lucide-react";

/** Data-blind message context, distinct from uploaded files. */
export function ContextAttachmentChips({
  items,
  onRemove,
}: {
  items: readonly { id: string; name: string }[];
  onRemove?: ((id: string) => void) | undefined;
}) {
  return (
    <ul
      aria-label="Attached widgets"
      className={
        onRemove
          ? "flex max-h-28 flex-wrap gap-1.5 overflow-y-auto"
          : "flex flex-wrap gap-1.5"
      }
    >
      {items.map((item) => (
        <li
          key={item.id}
          className="inline-flex max-w-full items-center gap-2 rounded-lg border border-pb-border-strong bg-pb-card px-2.5 py-1.5 text-xs text-pb-text-secondary"
        >
          <Layers className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
          <span className="min-w-0 break-words">{item.name}</span>
          {onRemove && (
            <button
              type="button"
              aria-label={"Remove " + item.name}
              onClick={() => onRemove(item.id)}
              className="flex h-6 w-6 shrink-0 items-center justify-center rounded text-pb-text-muted hover:text-pb-text focus-visible:outline focus-visible:outline-2 focus-visible:outline-pb-teal"
            >
              <X className="h-3.5 w-3.5" aria-hidden="true" />
            </button>
          )}
        </li>
      ))}
    </ul>
  );
}
